// 导出组件
export { GlobalErrorBoundary } from './components/GlobalErrorBoundary'
export { default as SentryErrorBoundary } from './components/SentryErrorBoundary'

// 导出配置
export type { SentryConfig } from './config'
export { defaultSentryConfig } from './config'

// 导出异步错误处理工具
export { default as useAsyncErrorBoundary } from './hooks/useAsyncErrorBoundary'

export {
  composeWrappers,
  withRetry,
  withSentryErrorHandling,
  withSilentErrorHandling,
  withTimeout,
} from './utils/asyncWrapper'

// 导出 axios 拦截器工具
export {
  createSentryEnhancedAxios,
  injectSentryInterceptors,
  type SentryInterceptorOptions,
} from './utils/axiosInterceptors'

// 导出全局单例函数
export { getGlobalSentry, initGlobalSentry } from './utils/init'
